var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-inbox" } }, [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        {
          staticClass: "header-item",
          on: {
            click: function ($event) {
              return _vm.$router.go(-1)
            },
          },
        },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("arrow_back")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [_vm._v("Geri")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-item", on: { click: _vm.filterNotRead } },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("inbox")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [
            _vm._v("Gelen Kutusu (" + _vm._s(_vm.answerTotal.notRead) + ")"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-item", on: { click: _vm.filterRead } },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("send")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [
            _vm._v("Okundu (" + _vm._s(_vm.answerTotal.read) + ")"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-item", staticStyle: { opacity: "0.5" } },
        [
          _c("md-icon", { staticClass: "icon" }, [_vm._v("archive")]),
          _vm._v(" "),
          _c("span", { staticClass: "header-text" }, [_vm._v("Arşiv")]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "inbox-menu" },
        [
          !_vm.loading
            ? _c("InboxMenu", {
                attrs: { answersData: _vm.filteredAnswers },
                on: { "item-selected": _vm.formAnswers },
              })
            : _c("div", { staticClass: "spinner" }, [_vm._v("Loading...")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inbox-content" },
        [
          _vm.selectedAnswer
            ? _c("InboxContents", {
                attrs: {
                  answersData: _vm.selectedAnswer,
                  "not-read-btn": _vm.notReadBtn,
                },
                on: { "mark-as-read": _vm.updateData },
              })
            : _c("div", [
                _vm._v(
                  "\n                Select an item to see details.\n            "
                ),
              ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }